// Bounds

function Bounds(top, left, width, height, scale) {

  scale = scale || 1;

  this.width = width ? width * scale : 0;
  this.height = height ? height * scale : 0;

  this.top = top ? top * scale : 0;
  this.left = left ? left * scale : 0;
  this.right = this.left + this.width;
  this.bottom = this.top + this.height;

  this._scale = scale;

}

Bounds.prototype.move = function(left, top) {

  this.top = top;
  this.left = left;
  this.right = this.left + this.width;
  this.bottom = this.top + this.height;

  return this;

};

Bounds.prototype.resize = function(width, height) {

  this.width = width;
  this.height = height;
  this.right = this.left + this.width;
  this.bottom = this.top + this.height;

  return this;

};

Bounds.prototype.setSize = Bounds.prototype.resize; // TODO

Bounds.prototype.scale = function(scale) {

  this.width *= scale;
  this.height *= scale;

  this.top *= scale;
  this.left *= scale;

  this.right = this.left + this.width;
  this.bottom = this.top + this.height;

  return this;

};

Bounds.prototype.clone = function() {

  var scale = this._scale;

  return new Bounds(
    this.top / scale,
    this.left / scale,
    this.width / scale,
    this.height / scale,
    scale
  );

};

Bounds.prototype.center = function() {

  return new Vector2(
    this.left + this.width / 2,
    this.top + this.height / 2
  );

};

Bounds.prototype.getCenter = Bounds.prototype.center; // TODO

Bounds.prototype.contains = function(vector, density) {

  var left = this.left / density;
  var top = this.top / density;

  var width = this.width / density;
  var height = this.height / density;

  var inX = vector.x > left && vector.x < left + width;
  var inY = vector.y > top && vector.y < top + height;

  return inX && inY;

};

Bounds.prototype.inBounds = function(x, y) { // TODO
  return (x > this.left &&
    x < this.left + this.width &&
    y > this.top &&
    y < this.top + this.height);
};

Bounds.prototype.inVector2 = function(v) { // TODO
  return (v.x > this.left &&
    v.x < this.left + this.width &&
    v.y > this.top &&
    v.y < this.top + this.height);
};

Bounds.prototype.getScaledBounds = function() {

  return this.clone().scale(1 / this._scale);

};

Bounds.prototype.getRelativePoint = function(x, y) {

  return new Vector2(x - this.left, y - this.top);

};

// Method to get the raw coordinates
Bounds.prototype.toObject = function() {

  return {
    top: this.top,
    left: this.left,
    width: this.width,
    height: this.height,
    scale: this.scale,
  };

};
